import FormInputs from "./FormInputs";
const GlobalSearchPopover = ({options,value,onChange}) => {
  return (
    <div style={{
        position: "fixed",
        top: "15px",
        right: "220px",
        transform: "translateX(-50%)",
        zIndex: 2000,
        background: "white",
        padding: "3px 3px", 
       
        
   }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <FormInputs
          type="SelectSearchList"
          style={{ borderWidth: "0px", marginLeft: "12px", width: "450px" ,position:"fixed"}}
          className="form-control form-control-solid"
          value={value}
          options={options}
          changeHandler={onChange}
        />
      </div>
    </div>
  );
};

export default GlobalSearchPopover;



